import backend, {PAYMENT_API} from 'utils/backend/server/api_library';

const getExpenseReimbursement = (eventRn) => {
  const url = `${PAYMENT_API}/payment/expense/reimbursement/${eventRn}`;
  return backend.get(url);
};

export default {
  getExpenseReimbursement,
};
